import { useTranslator } from '@Localization';
import { ReactElement } from 'react';
import { S_Checkbox } from '../../../../design/inputs/checkbox/S_Checkbox';

interface IProps {
  checked: boolean;
  disabled: boolean;
  onChange: () => void;
}

export const CursorGuidesCheckbox = ({ checked, disabled, onChange }: IProps): ReactElement => {
  const { t } = useTranslator();

  return (
    <S_Checkbox
      id='cursor-guides-checkbox'
      disabled={disabled}
      checked={checked}
      onChange={onChange}
      label={t('editor.cursor_control.enable_cursor_guides')}
    />
  );
};
